export default class Bookmarks {
  constructor() {
    this.products = JSON.parse(localStorage.getItem('products')) || [];
    this.bookmarks = document.querySelector('.bookmarks');
    this.bookmarkCounter = document.querySelector('.bookmarks .number');
    this.bookmarkList = document.querySelector('.bookmarks .bookmarks-list');
    this.bookmarkLink = document.querySelector('.bookmark-link');
    this.bookmarkItemsInput = document.querySelector('input.bookmarks-items');

    window.addEventListener('load', () => {
      this.setCount();

      let productInfo = document.querySelector('.product-info');

      if (productInfo) {
        let id = productInfo.dataset.id;
        let currentProduct = this.getProduct(id);
        if (this.bookmarkLink) {
          if (!!currentProduct) this.bookmarkLink.classList.add('active');
        }
      }

      this.bookmarkList.innerHTML = '';
      Array.prototype.forEach.call(this.products, el => {
        this.bookmarkList.appendChild(this.createBookmarkListItemTemplate(el));
        this.bookmarks.classList.add('bookmarks--has-items');
      });

      this.updateForm();
    });

    if (this.bookmarkLink) {
      this.bookmarkLink.addEventListener('click', (e) => {
        e.preventDefault();

        let el = e.target.closest('.bookmark-link');
        let info = e.target.closest('.product-info');
        let id = info.dataset.id;

        if (this.getProduct(id) && el.classList.contains('active')) {
          this.deleteProduct(id);
          el.classList.remove('active');
        } else {
          let product = {
            id: id,
            name: info.querySelector('h1').innerHTML,
            url: info.dataset.url
          };

          this.addProduct(product);
          el.classList.add('active');
        }
      });
    }

    this.bookmarks.querySelector('form').addEventListener('submit', (e) => {
      document.body.classList.add('is-submitting');
    });
  }

  createBookmarkListItemTemplate(product) {
    let productTemplate = document.createElement('DIV');
    productTemplate.className = 'dropdown-item';
    productTemplate.dataset.id = product.id;

    let productTemplateLinkDelete = document.createElement('SPAN');
    productTemplateLinkDelete.className = 'dropdown-item-delete';

    let productTemplateLink = document.createElement('A');
    productTemplateLink.href = product.url;
    productTemplateLink.innerHTML = product.name.replace(/<\/?[^>]+(>|$)/g, "");

    productTemplate.appendChild(productTemplateLink);
    productTemplate.appendChild(productTemplateLinkDelete);

    productTemplateLinkDelete.addEventListener('click', (e) => {
      let id = e.target.parentNode.dataset.id;

      this.deleteProduct(id);

      let productInfoSection = document.querySelector('.product-info');
      if (productInfoSection && productInfoSection.dataset.id === id) {
        productInfoSection.querySelector('.bookmark-link').classList.remove('active');
      }
    });

    return productTemplate;
  }

  setCount(n) {
    if (!n) {
      this.bookmarkCounter.innerHTML = this.getCount() || '';
    } else {
      this.bookmarkCounter.innerHTML = n || '';
    }
  }

  getCount() {
    return this.getProducts().length || 0;
  }

  getProducts() {
    return this.products;
  }

  getProduct(id) {
    return this.products.find(el => el.id === id) || null;
  }

  getProductIndex(id) {
    let index = 0;
    let i = 0;

    Array.prototype.forEach.call(this.getProducts(), el => {
      if (el.id === id) index = i;
      i++;
    });

    return index;
  }

  addProduct(product) {
    let products = this.getProducts();
    let isProductNew = !!this.getProduct(product.id);

    if (!isProductNew) {
      this.products.push(product);
      this.bookmarkList.appendChild(this.createBookmarkListItemTemplate(product));
    } else {
      this.products[this.getProductIndex(product.id)] = product;
    }

    this.bookmarks.classList.add('bookmarks--has-items');
    this.setCount();
    localStorage.setItem('products', JSON.stringify(products));
    this.updateForm();
  }

  deleteProduct(id) {
    let isInArray = !!this.getProduct(id);
    if (isInArray) {
      this.products = this.getProducts().filter(el => el.id !== id);

      localStorage.removeItem('products');
      localStorage.setItem('products', JSON.stringify(this.products));

      this.bookmarkList.querySelector(`[data-id="${id}"]`).remove();
    }

    if (!this.getCount()) {
      this.bookmarks.classList.remove('bookmarks--has-items');
    }
    this.setCount();
    this.updateForm();
  }

  updateForm() {
    this.bookmarkItemsInput.value = JSON.stringify(this.products);
  }
}
